module.exports = "/_next/static/files/88843d4dd00d4906dad9965aa86ce18e.jpg";